import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const IssueTypeFieldsRevisionSettingsDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId"
					to="/$organizationId/settings/issue-types/$issueTypeId/fields"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Fields
					</Button>
				</Link>
			}
		/>
	)
})
IssueTypeFieldsRevisionSettingsDetailViewTopBar.displayName = "IssueTypeFieldsRevisionSettingsDetailViewTopBar"
